import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { first, firstValueFrom } from 'rxjs';
import { DEFAULT_ENTITLEMENT_MODE, Entitlement, EntitlementMode } from './entitlement.model';
import { EntitlementService } from './entitlement.service';

export function EntitlementsGuard(
  required: Entitlement | readonly Entitlement[],
  {
    mode = DEFAULT_ENTITLEMENT_MODE,
    redirectTo,
  }: { mode?: EntitlementMode; redirectTo?: string | readonly string[] } = {},
): CanActivateFn {
  return async () => {
    const entitlementService = inject(EntitlementService);
    const router = inject(Router);

    await firstValueFrom(entitlementService.initialized$.pipe(first(Boolean)));

    if (entitlementService.has(required, mode)) {
      return true;
    }

    if (redirectTo) {
      if (Array.isArray(redirectTo)) {
        return router.createUrlTree(redirectTo);
      }

      if (typeof redirectTo === 'string') {
        return router.parseUrl(redirectTo);
      }
    }

    return false;
  };
}
